import { Pipe, PipeTransform } from '@angular/core';
import PrettySequenceHelper from 'src/app/shared/form-builder-util/pretty-sequence';

@Pipe({ 
    name: 'prettySectionSequence' 
})
export class PrettySectionSequencePipe implements PipeTransform {
    transform(value: number[]) {
        let ret = PrettySequenceHelper.formatSequence(value);
        return ret;
    }
}
